module.exports = __webpack_public_path__ + "media/images/logos/unscreen-14d46534f553a346eba56efa532391e4.svg";